module.exports = __webpack_public_path__ + "img/AT0000000696714.d5503b60.png";